import { KbChatMessage } from '../api/types';
import { renderMarkdown } from '../lib/sanitize';
import { formatMessageTime } from '../lib/formatTime';
import { Sources } from './Sources';

export function Message({ message }: { message: KbChatMessage }) {
  const isUser = message.role === 'user';
  return (
    <div class={`aj-msg ${isUser ? 'aj-msg--user' : 'aj-msg--assistant'}`}>
      <div class="aj-msg__content">
        {isUser ? (
          <span class="aj-plain">{message.content}</span>
        ) : (
          // Model output — sanitized by renderMarkdown before reaching innerHTML.
          <div
            class="aj-markdown"
            dangerouslySetInnerHTML={{ __html: renderMarkdown(message.content) }}
          />
        )}
      </div>
      {message.sources && message.sources.length > 0 && <Sources sources={message.sources} />}
      <div class="aj-msg__time">{formatMessageTime(message.timestamp)}</div>
    </div>
  );
}
